
















import type { PropType } from '@nuxtjs/composition-api';
// eslint-disable-next-line no-duplicate-imports
import { computed, defineComponent } from '@nuxtjs/composition-api';

import { getUniqueId } from '~/diptyqueTheme/helpers/getUniqueId';
import type { ContentType } from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  name: 'SectionsList',
  components: {
    HeroHeader: () => import('templates/sections/HeroHeader/index.vue'),
    InstitutionalPush: () =>
      import('templates/sections/InstitutionalPush/index.vue'),
    BlockInternalNavigation: () =>
      import('templates/sections/BlockInternalNavigation/index.vue'),
    LinkInternalNavigation: () =>
      import('templates/sections/LinkInternalNavigation/index.vue'),
    ProductBanner: () => import('templates/sections/ProductBanner/index.vue'),
    ProductPush: () => import('templates/sections/ProductPush/index.vue'),
    ProductSlider: () => import('templates/sections/ProductSlider/index.vue'),
    EditoProductPush: () =>
      import('templates/sections/EditoProductPush/index.vue'),
    HighlightEcom: () => import('templates/sections/HighlightEcom/index.vue'),
    EcomPush: () => import('templates/sections/EcomPush/index.vue'),
    SeoTextBlock: () => import('templates/sections/SeoTextBlock/index.vue'),
    EditorialPush: () => import('templates/sections/EditorialPush/index.vue'),
    EditorialBanner: () =>
      import('templates/sections/EditorialBanner/index.vue'),
    EditorialCard: () => import('templates/sections/EditorialCard/index.vue'),
    Gallery: () => import('organisms/product/Gallery/ProductGallery.vue'),
    Instalike: () => import('templates/sections/Instalike/index.vue'),
    CandleDuet: () => import('organisms/VaimoCandleDuet.vue'),
    Storytelling: () =>
      import('templates/sections/StoryTellingContent/index.vue'),
    Testimony: () => import('templates/sections/Testimony/index.vue'),
    PostCard: () => import('templates/sections/PostCard/index.vue'),
    Placeholder: () => import('templates/sections/PlaceholderSection.vue'),
    CommitmentPush: () => import('templates/sections/CommitmentPush/index.vue'),
    CollectionSlider: () =>
      import('templates/sections/CollectionSlider/index.vue'),
    CampaignPush: () => import('templates/sections/CampaignPush/index.vue'),
    ExploreSlider: () => import('templates/sections/ExploreSlider/index.vue'),
    Flexible: () => import('templates/sections/Flexible/index.vue'),
    GoodToKnowPanel: () =>
      import('templates/sections/GoodToKnowPanel/index.vue'),
    ArticleSection: () => import('templates/sections/ArticleSection/index.vue'),
    Paragraph: () => import('templates/sections/Paragraph/index.vue'),
    ListenToTheScent: () =>
      import('templates/sections/ListenToTheScent/index.vue'),
    AudioStory: () => import('templates/sections/AudioStory/index.vue'),
    Spotify: () => import('templates/sections/Spotify/index.vue'),
    CollectionPush: () => import('templates/sections/CollectionPush/index.vue'),
    BaseSection: () => import('templates/sections/BaseSection.vue'),
    ProductSingleSection: () =>
      import('templates/sections/ProductSingleSection.vue'),
    ProductsSection: () => import('templates/sections/ProductsSection.vue'),
    BundleProduct: () =>
      import(
        '~/modules/catalog/product/components/product-types/bundle/BundleProduct.vue'
      ),
    SectionModal: () => import('templates/sections/SectionModal/index.vue'),
    Spacing: () => import('templates/sections/SpacingSection/index.vue')
  },
  props: {
    items: {
      type: Array as PropType<ContentType[]>,
      required: false,
      default: () => []
    },
    config: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    pageName: {
      type: String,
      required: false,
      default: ''
    },
    pageType: {
      type: String,
      required: false,
      default: ''
    },
    fullHeight: {
      type: Boolean,
      required: false,
      default: false
    },
    moduleClasses: {
      type: String,
      required: false,
      default: ''
    },
    preloadMedia: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  setup(props) {
    const sections = computed(() => {
      const _sections = Array.isArray(props.items)
        ? props.items.filter(Boolean)
        : [];

      if (_sections.length && props.preloadMedia) {
        _sections[0].preloadMedia = true;
      }

      return _sections;
    });

    const getSectionKey = (section: ContentType, idx: string | number) => {
      const type = section.__typename;
      const id = section.sys?.id || getUniqueId();

      return [type, id, idx].join('__');
    };

    return {
      sections,
      getSectionKey
    };
  }
});
